import React from 'react'

import { useTheme } from '../core'
import { media, Theme } from '../themes'
import { useMediaQuery } from './useMediaQuery'

/**
 * @deprecated due to CLS problems during SSR
 */
export const useBreakpoint = (): {
  breakpoint: keyof Theme['breakpoints'] | 'sp' | null
  isReady: boolean
  isSp: boolean
  isTablet: boolean
  isPc: boolean
} => {
  const theme = useTheme()
  const [breakpoint, setBreakpoint] = React.useState<
    'sp' | 'tablet' | 'pc' | null
  >(null)

  const { mediaTablet, mediaPc } = React.useMemo(
    () => ({
      mediaTablet: media.tablet({ theme }),
      mediaPc: media.pc({ theme }),
    }),
    [theme],
  )

  const isTablet = useMediaQuery(mediaTablet)
  const isPc = useMediaQuery(mediaPc)

  // Wrap in useEffect so that it is initially rendered as `null` in the server-side,
  // then re-render on the client-side with the actual breakpoint
  React.useEffect(() => {
    setBreakpoint(isPc ? 'pc' : isTablet ? 'tablet' : 'sp')
  }, [isTablet, isPc])

  return {
    breakpoint,
    isReady: breakpoint !== null,
    isSp: breakpoint === 'sp',
    isTablet: breakpoint === 'tablet',
    isPc: breakpoint === 'pc',
  }
}
